import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, btnStyle, inputStyle } from '../theme';

const dowNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

const DynamicPricingPage = ({ API_BASE }) => {
  const [data, setData] = useState(null);
  const [quote, setQuote] = useState({ dow: 1, hour: 18, basePrice: 1500 });
  const [quoteResult, setQuoteResult] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/dynamic-pricing/heatmap?days=90`).then(r => setData(r.data)).catch(() => {});
  }, [API_BASE]);

  const runQuote = async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/dynamic-pricing/quote`, { params: quote });
      setQuoteResult(data);
    } catch (e) { alert('Quote failed'); }
  };

  const cellColor = (count, max) => {
    if (!max || !count) return '#f1f5f9';
    const intensity = count / max;
    if (intensity >= 0.8) return '#dc2626';
    if (intensity >= 0.5) return '#f59e0b';
    if (intensity >= 0.25) return '#fbbf24';
    return '#d1fae5';
  };

  return (
    <div>
      <div style={{ ...cardStyle, marginBottom: 14 }}>
        <h2 style={{ margin: 0, color: theme.navy }}>💹 Dynamic Pricing</h2>
        <p style={{ margin: '6px 0', fontSize: 13, color: theme.textMuted }}>
          Peak/off-peak multipliers derived from 90-day appointment demand. Use these suggestions to raise prices in packed slots and discount quiet ones.
        </p>
      </div>

      {/* Quote tool */}
      <div style={{ ...cardStyle, marginBottom: 14 }}>
        <h3 style={{ margin: '0 0 10px' }}>Quick Quote</h3>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'end' }}>
          <div><label>Day</label>
            <select value={quote.dow} onChange={e => setQuote({ ...quote, dow: Number(e.target.value) })} style={inputStyle}>
              {dowNames.map((n, i) => <option key={i} value={i}>{n}</option>)}
            </select>
          </div>
          <div><label>Hour (24h)</label>
            <input type="number" min={0} max={23} value={quote.hour} onChange={e => setQuote({ ...quote, hour: Number(e.target.value) })} style={inputStyle}/>
          </div>
          <div><label>Base Price ₹</label>
            <input type="number" value={quote.basePrice} onChange={e => setQuote({ ...quote, basePrice: Number(e.target.value) })} style={inputStyle}/>
          </div>
          <button onClick={runQuote} style={{ ...btnStyle, marginTop: 0 }}>Quote</button>
        </div>
        {quoteResult && (
          <div style={{ marginTop: 14, padding: 14, background: '#f0fdf4', borderRadius: 8, borderLeft: `4px solid ${theme.success}` }}>
            <div style={{ fontSize: 13, color: theme.textMuted }}>Suggested Price</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: theme.navy }}>₹{quoteResult.suggestedPrice.toLocaleString()}</div>
            <div style={{ fontSize: 13 }}>
              <strong>{quoteResult.band.toUpperCase()}</strong> × {quoteResult.multiplier} — {quoteResult.reason}
            </div>
          </div>
        )}
      </div>

      {/* Heatmap */}
      {data && (
        <div style={cardStyle}>
          <h3 style={{ margin: '0 0 10px' }}>Demand Heatmap ({data.totalAppointments} appts over {data.scannedDays} days)</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', fontSize: 11 }}>
              <thead>
                <tr>
                  <th style={{ padding: 4 }}></th>
                  {Array.from({ length: 12 }, (_, i) => i + 9).map(h => (
                    <th key={h} style={{ padding: 4, fontWeight: 600 }}>{h}:00</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dowNames.map((dn, dow) => (
                  <tr key={dow}>
                    <td style={{ padding: 4, fontWeight: 700 }}>{dn}</td>
                    {Array.from({ length: 12 }, (_, i) => i + 9).map(h => (
                      <td key={h} style={{ padding: 0 }}>
                        <div style={{
                          width: 44, height: 32, lineHeight: '32px', textAlign: 'center',
                          background: cellColor(data.grid[dow][h], data.max),
                          color: data.grid[dow][h] >= 0.5 * data.max ? 'white' : '#111',
                          borderRadius: 3, margin: 1, fontWeight: 700,
                        }} title={`${dn} ${h}:00 — ${data.grid[dow][h]} appts`}>{data.grid[dow][h] || '·'}</div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: theme.textMuted }}>
            Red = peak (raise prices 15%) · Green = quiet (offer 10% off) · Amber = normal
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicPricingPage;
